import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  ActionBar,
  ActionBarItem,
  Body,
  checkPrivilege,
  Column,
  createAllItemCountSelector,
  createListErrorSelector,
  createListSelector,
  DetailPanel,
  Equals,
  FilterCombo,
  FilterObject,
  Header,
  Link,
  List,
  load,
  Pagination,
  Panel,
  Protected,
  remove,
  SimpleDropdown,
  translate
} from "clavis-nxt-components-custdevtm";
import { ModuleEntity } from "./domain/ModuleEntity";
import { TranslateForAdminEntity } from "./domain/TranslateForAdminEntity";
import { TranslateModal } from "./components/TranslateModal/TranslateModal";
import { getPrivileges } from "util/auth/Privileges";
import "./TranslatePage.scss";

class TranslatePageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      actualPage: 1,
      advancedSearchFilter: new FilterObject(
        TranslateForAdminEntity,
        "TranslateForAdminEntity"
      ),
      criteriaFilterList: [],
      filterComboLimit: 4,
      firstItem: 0,
      isOpenTranslateModal: false,
      modifyTranslateModalOpen: false,
      newTranslateModalOpen: false,
      numberOfItemsPerPage: 10,
      sortBy: "labelCode",
      sortDirection: "asc",
      selectedRow: {}
    };
  }

  componentDidMount() {
    const filterObj = new FilterObject(ModuleEntity, "ModuleEntity");
    this.props.loadAll(filterObj).promise.then(() => {
      this.setState(
        { selectedGroup: this.props.modules ? this.props.modules[0] : null },
        this.criteriasChanged
      );
    });
  }

  selectListPage = (actualPage, firstItem) =>
    this.setState({ actualPage, firstItem }, this.criteriasChanged);

  criteriasChanged = () => {
    if (this.state.selectedGroup) {
      let filterObj = null;
      if (this.state.advancedSearchFilter.criteria.length !== 0) {
        filterObj = _.cloneDeep(this.state.advancedSearchFilter);
      } else {
        filterObj = new FilterObject(
          TranslateForAdminEntity,
          "TranslateForAdminEntity"
        );
      }

      filterObj.addSorting(this.state.sortBy, this.state.sortDirection);

      filterObj.addPaging(
        this.state.firstItem,
        this.state.numberOfItemsPerPage
      );

      this.state.criteriaFilterList.forEach(crit => {
        filterObj.add(crit);
      });

      filterObj.add(new Equals("moduleCode", this.state.selectedGroup.code));

      this.props.loadAll(filterObj).promise.then(() => {
        this.setState({
          selectedRow: this.props.entities[0]
        });
      });
    }
  };

  deleteRow = entity => {
    this.props.delete(entity).promise.then(() => this.criteriasChanged());
  };

  detailPanelContent = props => {
    const { t } = this.props;
    return (
      <div className="panel-items interaction-color">
        <div>
          {" "}
          <Protected privilege={"ui_plf_localization_modify"}>
            <Link click={() => this.toggleTranslateModal(true)}>
              {t("page.TranslationPage.detailsPanel.modify")}
            </Link>
          </Protected>
        </div>
        <div>
          {" "}
          <Protected privilege={"ui_plf_localization_modify"}>
            <Link
              click={() => this.deleteRow(props.entity)}
              className={
                getPrivileges().includes("ui_plf_localization_modify")
                  ? "failed-color"
                  : ""
              }
            >
              {t("page.TranslationPage.detailsPanel.delete")}
            </Link>
          </Protected>
        </div>
      </div>
    );
  };

  sortByCallback = sortBy => {
    let sortDirection = "asc";
    if (this.state.sortBy === sortBy) {
      sortDirection = this.state.sortDirection === "asc" ? "desc" : "asc";
    }
    this.setState({ sortBy, sortDirection }, this.criteriasChanged);
  };

  selectRowCallback = selectedRow => this.setState({ selectedRow });

  filterOnChange = criteriaList => {
    if (criteriaList.length > this.state.filterComboLimit) {
      this.setState({
        filterComboWarning: this.props.t("components.FilterCombo.Warning")
      });
    } else {
      this.setState(
        {
          actualPage: 1,
          criteriaFilterList: criteriaList,
          filterComboWarning: "",
          firstItem: 0
        },
        this.criteriasChanged
      );
    }
  };

  selectGroup = selected => {
    this.setState(
      { selectedGroup: selected, actualPage: 1, firstItem: 0 },
      this.criteriasChanged
    );
  };

  /** Toggling modify modal isOpen variable.
   *  @param {boolean} [modify=false] - Modify indicator. */
  toggleTranslateModal = (modify = false) =>
    this.setState(prevState => ({
      isOpenTranslateModal: !prevState.isOpenTranslateModal,
      modify: typeof modify === "boolean" ? modify : false
    }));

  render() {
    const { t } = this.props;

    return (
      <div className="translation-page">
        <Panel className="translation-panel">
          <Header>
            <div>
              <div className="">
                <ActionBar>
                  <div className="next-in-line">
                    <SimpleDropdown
                      direction="down"
                      labelProperty="code"
                      label={t("page.TranslationPage.moduleGroup")}
                      data={this.props.modules}
                      selected={this.state.selectedGroup}
                      noTranslate={false}
                      nullable={false}
                      onSelected={this.selectGroup}
                    />
                  </div>
                </ActionBar>
              </div>
              <div className={"row header-content"}>
                <div className="col-3 title huge-font-medium header-color">
                  {t("page.TranslationPage.pageTitle")}
                  <ActionBar>
                    <ActionBarItem
                      labelColor="interaction-color"
                      icon="icon-refresh interaction-color"
                      onClick={this.criteriasChanged}
                    />
                    <Protected privilege={"ui_plf_localization_modify"}>
                      <ActionBarItem
                        icon="icon-addnew interaction-color"
                        labelColor="interaction-color"
                        labelRight={t(
                          "page.TranslationPage.newTranslateButton"
                        )}
                        onClick={this.toggleTranslateModal}
                      />
                    </Protected>
                  </ActionBar>
                </div>
                <div className="col-9 filter-combo-box">
                  <FilterCombo
                    entityType={TranslateForAdminEntity}
                    filteredProps={[
                      "labelCode",
                      "translationValue.hu",
                      "translationValue.en"
                    ]}
                    criteriaList={this.state.criteriaFilterList}
                    onChange={this.filterOnChange}
                    warning={this.state.filterComboWarning}
                    limit={this.state.filterComboLimit}
                    dropDownDefaultValue={false}
                    filterOnEnter={true}
                    scrollItemList={true}
                    entitySortDirection={true}
                    advancedSearchFilter={this.state.advancedSearchFilter}
                    advancedSearchFilterCallback={newFilter => {
                      this.setState(
                        {
                          actualPage: 1,
                          advancedSearchFilter: newFilter,
                          firstItem: 0
                        },
                        () => this.filterOnChange([])
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </Header>
          <Body>
            <div className={"translation-container"}>
              <List
                selectedRow={this.state.selectedRow}
                selectRowCallback={this.selectRowCallback}
                id="base-instruments-table"
                entities={this.props.entities}
                markHoveredRow={true}
                sortByCallback={this.sortByCallback}
                sortBy={this.state.sortBy}
                sortDirection={this.state.sortDirection}
                hasErrorFromServer={this.props.createListErrorSelector}
                onRowDoubleClick={() => {
                  if (checkPrivilege("ui_plf_localization_modify")) {
                    this.toggleTranslateModal(true);
                  }
                }}
              >
                <Column
                  sortable={true}
                  propName="labelCode"
                  title={t(
                    "page.TranslationPage.TranslateForAdminEntity.labelCode"
                  )}
                />
                <Column
                  sortable={true}
                  propName="translationValue.hu"
                  title={t(
                    "page.TranslationPage.TranslateForAdminEntity.translationValue.hu"
                  )}
                />
                <Column
                  sortable={true}
                  propName="translationValue.en"
                  title={t(
                    "page.TranslationPage.TranslateForAdminEntity.translationValue.en"
                  )}
                />
                <DetailPanel direction={"left"}>
                  <this.detailPanelContent />
                </DetailPanel>
              </List>
              <Pagination
                allItems={this.props.allItemCount}
                numberOfItemsPerPage={this.state.numberOfItemsPerPage}
                selectedPage={this.state.actualPage}
                selectPageFunc={this.selectListPage}
              />
              {this.state.isOpenTranslateModal && (
                <TranslateModal
                  entity={this.state.selectedRow}
                  isOpen={this.state.isOpenTranslateModal}
                  modify={this.state.modify}
                  moduleCode={this.state.selectedGroup.code}
                  toggle={this.toggleTranslateModal}
                />
              )}
            </div>
          </Body>
        </Panel>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadAll: filterObject => dispatch(load(filterObject)),
  delete: entity => dispatch(remove(entity))
});

const mapStateToProps = (state, props) => {
  return {
    entities: createListSelector(
      TranslateForAdminEntity,
      "TranslateForAdminEntity"
    )(state, props),
    modules: createListSelector(ModuleEntity, "ModuleEntity")(state, props),
    allItemCount: createAllItemCountSelector(
      TranslateForAdminEntity,
      "TranslateForAdminEntity"
    )(state, props),
    createListErrorSelector: createListErrorSelector(
      TranslateForAdminEntity,
      "TranslateForAdminEntity"
    )(state, props)
  };
};

export const TranslatePage = translate()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TranslatePageComponent)
);
